import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#0a1628] text-white h-14 flex items-center justify-between px-4 md:px-8 shadow-md border-b border-gray-800" data-id="element-167">
      {/* Logo / brand – desktop only */}
      <div className="flex items-center gap-4" data-id="element-168">
        <a href="tel:0523552222" className="hidden md:flex items-center gap-2 bg-[#f97316] hover:bg-orange-600 text-white px-4 py-1.5 rounded-full font-bold transition-colors text-sm" data-id="element-169">
          <PhoneIcon className="w-4 h-4" data-id="element-170" />
          <span data-id="element-171">התקשרו עכשיו</span>
        </a>
        <span className="font-bold text-lg tracking-wide hidden md:inline" data-id="element-172">
          יבש-טק פרו
        </span>
      </div>

      {/* Phone numbers */}
      <div className="flex items-center gap-2 md:gap-3 mr-auto" data-id="element-173">
        <span className="text-gray-300 text-sm hidden sm:inline" data-id="element-174">
          חירום 24/6:
        </span>

        {/* Mobile: show only first number, smaller */}
        <a href="tel:0523552222" className="font-black text-base sm:text-xl md:text-2xl tracking-wider hover:text-[#f97316] transition-colors" data-id="element-175">
          054-518-8888
        </a>

        {/* Desktop: separator + second number */}
        <span className="text-gray-500 hidden md:inline" data-id="element-176">|</span>
        <a href="tel:0545188888" className="font-black text-2xl tracking-wider hover:text-[#f97316] transition-colors hidden md:inline" data-id="element-177">
          052-355-2222
        </a>
      </div>
    </div>;
}